import React from 'react';

const ErrorHPID = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.171875" width="20" height="20" rx="10" fill="#EB5E5E" />
    <path
      d="M15.2498 10.7555H4.74984C4.42769 10.7555 4.1665 10.4946 4.1665 10.1722C4.1665 9.84977 4.42769 9.58887 4.74984 9.58887H15.2498C15.572 9.58887 15.8332 9.84977 15.8332 10.1722C15.8332 10.4946 15.572 10.7555 15.2498 10.7555Z"
      fill="#212121"
    />
  </svg>
);

export default ErrorHPID;
